/**
 * @description
 * Objeto webservicesparse
 */

import { Xmlfields } from "./xmlfields.model";
import { Permissions } from "./permissions.model";
import { WebserviceValorDato } from "./webservicevalordato.model";

export class WebservicesParse {
    
   public code: string;
   public cat: string;
   public esp: string;
   public codXmldef: string = "";
   public etiquetas: Array<Xmlfields>;
   public permisos: Array<Permissions>;
   public valores: Array<Array<WebserviceValorDato>>;
   public error:string = "";
 
   constructor() {}
 
}